import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import QRCode from "react-qr-code";
import { Copy, Check } from "lucide-react";
import { notify } from "../../services/notify.js";
import { trackMetaPurchase } from "../../utils/metaAds";
import "./pix_screen.css";

const PixLoadingMessage = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 20 ? prev + ". " : ""));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="pixs-loading">
      <span className="pixs-spinner"></span>
      Aguardando pagamento{dots}
    </div>
  );
};

const PixScreen = ({
  email,
  value,
  pix_code,
  subscription_id,
  onConfirmed,
  onChangeMethod,
}) => {
  const [copied, setCopied] = useState(false);
  const retryCount = useRef(0);
  const baseDelay = 1000;
  const maxDelay = 10000;

  useEffect(() => {
    let isCancelled = false;

    const checkPayment = async () => {
      if (isCancelled || !subscription_id) return;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT}/new_subscriptions/subscription-status/${subscription_id}`
        );
        const data = await response.json();

        if (data.status === "RECEIVED") {
          trackMetaPurchase(subscription_id, value);
          onConfirmed();
          return;
        }
      } catch (error) {
        console.error("Error verifying subscription payment:", error);
      }

      retryCount.current += 1;
      const nextDelay = Math.min(baseDelay * 2 ** retryCount.current, maxDelay);
      setTimeout(checkPayment, nextDelay);
    };

    checkPayment();

    return () => {
      isCancelled = true;
    };
  }, [subscription_id]);

  const handleCopy = () => {
    navigator.clipboard.writeText(pix_code);
    notify("CHECKOUT: pix", `Usuário ${email} copiou o código pix.`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="pixs">
      <h2 className="pixs-title">Falta pouco! Pague com Pix para liberar o acesso</h2>
      <p className="pixs-subtitle">
        Escaneie o QR Code ou copie o código abaixo no app do seu banco.
      </p>

      <div className="pixs-qr-section">
        {pix_code ? (
          <div className="pixs-qr">
            <QRCode value={pix_code} size={180} />
          </div>
        ) : (
          <div className="pixs-qr-placeholder">Gerando código Pix...</div>
        )}

        <div className="pixs-code-box">
          <div className="pixs-code-label">Código Pix (Copia e Cola)</div>
          <div className="pixs-code-row">
            <input
              type="text"
              value={pix_code}
              readOnly
              className="pixs-code-input"
              onClick={(e) => e.target.select()}
            />
            <Button
              onClick={handleCopy}
              className={`pixs-copy-btn ${copied ? "copied" : ""}`}
              variant="contained"
              startIcon={copied ? <Check size={16} /> : <Copy size={16} />}
            >
              {copied ? "Copiado!" : "Copiar"}
            </Button>
          </div>
        </div>
      </div>

      <PixLoadingMessage />

      <div className="pixs-instructions">
        <h3>Como pagar?</h3>
        <ol>
          <li>
            <strong>Abra o app do seu banco:</strong> escolha pagar via Pix e
            escaneie o QR Code ou use o Pix Copia e Cola.
          </li>
          <li>
            <strong>Confirme os dados:</strong> verifique o destinatário (DOMINIO
            ELETRICO ou N.Y.M.SUGIMOTO LTDA) e o valor de{" "}
            <strong>R$ {value}</strong>.
          </li>
          <li>
            <strong>Acesso liberado:</strong> a confirmação e os dados de acesso
            aparecerão aqui e no seu email em instantes.
          </li>
        </ol>
      </div>

      <div className="pixs-warning">⏱️ Este código Pix expira em 30 minutos.</div>

      <div className="pixs-change" onClick={onChangeMethod}>
        Mudar forma de pagamento
      </div>
    </div>
  );
};

export default PixScreen;
